// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
export const ComponentWarrantyActivationFormFragmentDoc = `
    fragment componentWarrantyActivationForm on ComponentWarrantyActivationForm {
  __typename
}
    `;